var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index uk-first-section-xlarge-padding"},[_c('index-top'),_vm._v(" "),_c('index-bottom',{attrs:{"active-filters":_vm.activeFilters}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }